import { keyframes, styled } from "styled-components";
import Window from "./Window";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-light-svg-icons";

const animationRoot = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;;
  }
`;

const animationInner = keyframes`
  from {
    opacity: 0;
    scale: 0.75;
  }

  to {
    opacity: 1;
    scale: 1;
  }
`;

const Root = styled.div`
  animation-duration: 250ms;
  animation-fill-mode: forwards;
  animation-name: ${animationRoot};
  animation-timing-function: ease-in;
  inset: 0;
  opacity: 0.5;
  position: absolute;
  z-index: 1;
`;

const ModalInner = styled(Window)`
  animation-duration: 250ms;
  animation-fill-mode: forwards;
  animation-name: ${animationInner};
  animation-timing-function: ease-in;
  display: flex;
  gap: var(--space-6);
  inset: var(--space-6);
  max-height: 100%;
  padding: var(--space-6);
  position: absolute;
  z-index: 2;
  overflow: hidden;

  .modalInner {
    inset: var(--space-12);
  }
`;

const ModalClose = styled.div`
  align-items: center;
  aspect-ratio: 1;
  border-bottom: var(--border);
  border-left: var(--border);
  display: flex;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
  width: var(--space-6);
`;

function Modal({ children, store, close, $padding, $size, $backgroundColor }) {
  return (
    <Root $size={$size}>
      <ModalInner className="modalInner" $size={$size} $backgroundColor={$backgroundColor}>
        {children}
        <ModalClose onClick={close ? close : () => store.setModal()}>
          <FontAwesomeIcon icon={faXmark} />
        </ModalClose>
      </ModalInner>
    </Root>
  )
}

export default Modal;